// extracted by mini-css-extract-plugin
export default {"Label":"_Label--knjbe","Icon":"_Icon--GtSIu","Description":"_Description--xp6Ta","Divider":"_Divider--ni7wy","Disabled":"_Disabled--VE0_x"};